import {
  UPDATE_PARAMS_SEARCH,
  UPDATE_PARAMS_DROPDOWN_FILTER,
  UPDATE_PARAMS_PERIOD_FILTER,
  UPDATE_PARAMS_REMOVE,
  UPDATE_PARAMS_UNIT_FILTER,
  UPDATE_PARAMS_LOCATION_MARKET_FILTER,
} from 'common/actions/query-params-actions';
import createCaseReducer from 'common/reducers/case-reducer';
import dropdownFilterReducer from './dropdown-filter-reducer';
import filterPillReducer from './filter-pill-reducer';
import periodSelectorReducer from './period-selector-reducer';
import unitSelectorReducer from './unit-selector-reducer';
import locationMarketSelectorReducer from './location-market-selector-reducer';
import searchBoxReducer from './search-box-reducer';

export default createCaseReducer(
  {},
  {
    [UPDATE_PARAMS_SEARCH]: searchBoxReducer,
    [UPDATE_PARAMS_DROPDOWN_FILTER]: dropdownFilterReducer,
    [UPDATE_PARAMS_PERIOD_FILTER]: periodSelectorReducer,
    [UPDATE_PARAMS_REMOVE]: filterPillReducer,
    [UPDATE_PARAMS_UNIT_FILTER]: unitSelectorReducer,
    [UPDATE_PARAMS_LOCATION_MARKET_FILTER]: locationMarketSelectorReducer,
  },
);
